import { appStore } from '~/utils/store-accessor';
const maintenanceGlobalMiddleware = ({ error }) => {
    var _a;
    if (appStore.maintenance && ((_a = appStore.maintenance.app) === null || _a === void 0 ? void 0 : _a.active)) {
        error({ statusCode: 503, message: 'MAINTENANCE' });
    }
};
export default maintenanceGlobalMiddleware;
